export default __webpack_public_path__ + "static/media/claim-your-own-name.a67d4515.svg";